module.exports = __webpack_public_path__ + "4f92e888.png";